module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/check-circle-ub.90830f81.svg";